import { useEffect, useRef } from 'react';
import { forEach, join } from '@libs/shared';
import { triggerHowxmEvent } from '@fx-ui/platform-sdk';
import { HOWXM } from '~/constants';

interface IUseEventHowxmProps {
    needHowxm?: boolean;
    eventCode: (typeof HOWXM)[keyof typeof HOWXM];
    eventAttrs?: Record<string, string>;
    deps?: any[];
}

const ATTR_SEP = '+';

const useEventHowxm = (props: IUseEventHowxmProps) => {
    const { needHowxm, eventCode, eventAttrs, deps = [] } = props;

    const timeoutRef = useRef<number>();

    useEffect(() => {
        if (needHowxm) {
            // 因为浩客每个事件只能配置1个条件，所以将多个属性值用+号拼接
            const valueArr: string[] = [];
            forEach(eventAttrs, (value) => {
                valueArr.push(value);
            });
            const eventAttr = { name: join(valueArr, ATTR_SEP) };
            // 页面加载时直接触发浩客事件大概率不会弹出问卷，暂时通过延迟触发来规避，待后续优化
            if (timeoutRef.current) {
                window.clearTimeout(timeoutRef.current);
            }
            timeoutRef.current = window.setTimeout(() => {
                triggerHowxmEvent(eventCode, eventAttr);
            }, 1000);
        }
        return () => {
            if (timeoutRef.current) {
                window.clearTimeout(timeoutRef.current);
            }
        };
    }, [...deps]);
};

export default useEventHowxm;
